var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "title mb-40" }, [
      _vm._v("padrão de assinaturas")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "buttons-filters mt-50" }, [
      _c(
        "div",
        [
          _c(
            "router-link",
            { staticClass: "new-group", attrs: { to: "nova-assinatura" } },
            [
              _c("img", {
                attrs: { src: require("../../../static/plus.svg") }
              }),
              _vm._v(" Criar regra\n      ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-center" }, [
      _c("div", { staticClass: "default-subscription" }, [
        _c("div", { staticClass: "default-title" }, [_vm._v("B2B")]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-20" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v("máximo de pausas por ano:")
          ]),
          _vm._v(" "),
          _c("input", { attrs: { type: "text" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-20" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v("dias máximo por pausa:")
          ]),
          _vm._v(" "),
          _c("input", { attrs: { type: "text" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn bg-purple save" }, [_vm._v("salvar")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "default-subscription" }, [
        _c("div", { staticClass: "default-title" }, [_vm._v("B2C")]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-20" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v("máximo de pausas por ano:")
          ]),
          _vm._v(" "),
          _c("input", { attrs: { type: "text" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-20" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v("dias máximo por pausa:")
          ]),
          _vm._v(" "),
          _c("input", { attrs: { type: "text" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn bg-purple save" }, [_vm._v("salvar")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search" }, [
      _c("input", {
        staticClass: "with-icon icon-search sm",
        attrs: { type: "text", placeholder: "buscar" }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "btn bg-white-purple ml-10" }, [
        _vm._v("busca avançada")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table" }, [
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Tipo")]),
            _vm._v(" "),
            _c("th", [_vm._v("Cidade")]),
            _vm._v(" "),
            _c("th", [_vm._v("Distrito")]),
            _vm._v(" "),
            _c("th", [_vm._v("Pausas")]),
            _vm._v(" "),
            _c("th", [_vm._v("Limite")]),
            _vm._v(" "),
            _c("th")
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [_vm._v("Pelotas")]),
            _vm._v(" "),
            _c("td", [_vm._v("Laranjal")]),
            _vm._v(" "),
            _c("td", [_vm._v("2")]),
            _vm._v(" "),
            _c("td", [_vm._v("30 dias")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("editar")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [_vm._v("Pelotas")]),
            _vm._v(" "),
            _c("td", [_vm._v("Laranjal")]),
            _vm._v(" "),
            _c("td", [_vm._v("2")]),
            _vm._v(" "),
            _c("td", [_vm._v("30 dias")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("editar")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bebd95d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bebd95d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscription/Rules.vue
// module id = null
// module chunks = 